(function (){
    'use strict';

    angular
        .module('services')
        .service('LanguageCourseService', LanguageCourseService);

    LanguageCourseService.$inject = ['$http', 'API_BASE'];

    function LanguageCourseService ($http, API_BASE) {
        var service = this;

        service.getAll        = getAll;

        function getAll () {
            return $http.get(API_BASE + '/languageCourse/list');
        }

    }
})();